//
//
//
//
//
//
//
//
//

import icon from "../icon";
import Frame1162Svg from "./frame1162.svg?inline";
export default {
  name: "Frame1162Icon",
  components: {
    Frame1162Svg,
    icon
  }
};
